import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { products } from '../mock';
import { useLang } from '../i18n/LanguageContext';

const ProductsSection = ({ limit }) => {
  const { t, lang } = useLang();
  const items = limit ? products.slice(0, limit) : products;

  return (
    <section id="prodotti" className="py-24 bg-[#f5f7fa]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <p className="text-xs tracking-[0.3em] text-[#c53114] font-semibold uppercase">{t('products.eyebrow')}</p>
            <h2
              className="mt-2 text-3xl md:text-5xl font-semibold text-[#0b2545]"
              style={{ fontFamily: "'Barlow Condensed', 'Oswald', sans-serif", letterSpacing: '0.02em' }}
            >
              {t('products.title')}
            </h2>
            <p className="mt-4 max-w-2xl text-[#475569] leading-relaxed">{t('products.subtitle')}</p>
          </div>
          {limit && (
            <Link
              to="/prodotti"
              className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.2em] font-semibold text-[#0b2545] hover:text-[#c53114] transition-colors self-start md:self-end"
            >
              {t('products.all')} <ArrowUpRight size={18} />
            </Link>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {items.map((p) => {
            const c = p[lang] || p.en || p.it;
            return (
              <article
                key={p.id}
                className="group relative bg-white overflow-hidden shadow-sm hover:shadow-xl transition-shadow duration-500"
              >
                <div className="relative h-64 overflow-hidden">
                  <div
                    className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
                    style={{ backgroundImage: `url('${p.image}')` }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0b2545]/85 via-[#0b2545]/20 to-transparent" />
                  <div className="absolute bottom-5 left-5 right-5">
                    <p className="text-[10px] tracking-[0.3em] text-[#f2b8a6] uppercase">{c.subtitle}</p>
                    <h3
                      className="text-white text-2xl font-semibold mt-1"
                      style={{ fontFamily: "'Barlow Condensed', 'Oswald', sans-serif" }}
                    >
                      {c.title}
                    </h3>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-sm text-[#475569] leading-relaxed line-clamp-3 min-h-[4.5rem]">{c.description}</p>
                  <Link
                    to={`/prodotti/${p.id}`}
                    className="mt-5 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-[#c53114] hover:text-[#0b2545] transition-colors"
                  >
                    {t('products.discover')} <ArrowUpRight size={14} />
                  </Link>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
